<script setup>
import { computed } from "vue";

const props = defineProps({
    width: {
        type: [String, Number],
        default: "",
    },
    height: {
        type: [String, Number],
        default: "",
    },
    viewBox: {
        type: String,
        default: null,
    },
});

const viewBoxValue = computed(() => {
    return props.viewBox ? props.viewBox : `0 0 ${props.width} ${props.height}`;
});
</script>

<template>
    <svg :viewBox="viewBoxValue">
        <slot />
    </svg>
</template>
